import { DateTime } from 'luxon'

/**
 * Calculates Easter Sunday for a given year (Gregorian calendar).
 */
export function getEasterSunday(year: number) {
  // Position in the 19-year lunar (Metonic) cycle
  // A period after which the phases of the Moon recur on the same days of the calendar year
  const lunarCyclePosition = year % 19

  // Century and year within the century
  const century = Math.floor(year / 100)
  const yearInCentury = year % 100

  // Leap year corrections for the century: Number of leap years in the century
  const leapYearsInCentury = Math.floor(century / 4)
  const centuryRemainder = century % 4

  // Gregorian calendar correction factors: Adjustments to align the calendar with the solar year
  const gregorianCorrection = Math.floor((century + 8) / 25)
  const solarCorrection = Math.floor((century - gregorianCorrection + 1) / 3)

  // Epact: age of the moon on Jan 1 (determines Paschal full moon)
  // A correction factor for the lunar calendar: The number of days by which the solar year exceeds the lunar year.
  const epact = (19 * lunarCyclePosition + century - leapYearsInCentury - solarCorrection + 15) % 30

  // Leap year corrections within the century: Number of leap years in the year
  const leapYearsInYear = Math.floor(yearInCentury / 4)
  const yearRemainder = yearInCentury % 4

  // Day-of-week offset to reach the following Sunday: Helps determine the exact date of Easter Sunday
  const weekdayOffset = (32 + 2 * centuryRemainder + 2 * leapYearsInYear - epact - yearRemainder) % 7

  // Final correction to avoid rare early Easter dates: Ensures Easter falls within the correct range
  const finalCorrection = Math.floor((lunarCyclePosition + 11 * epact + 22 * weekdayOffset) / 451)

  // Calculate month and day: Final computation of Easter Sunday date
  const month = Math.floor((epact + weekdayOffset - 7 * finalCorrection + 114) / 31)
  const day = ((epact + weekdayOffset - 7 * finalCorrection + 114) % 31) + 1

  return DateTime.local(year, month, day).startOf('day')
}

export function getChristmasEve(year: number) {
  return DateTime.local(year, 12, 24).startOf('day')
}

export function getHalloween(year: number) {
  return DateTime.local(year, 10, 31).startOf('day')
}
